import {yupResolver} from '@hookform/resolvers/yup'
import {FC, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {useCentral} from '../../../../../hooks/useCentral'
import {TabCentralModel} from '../../../../../models'
import {
  ERROR_MESSAGE_SYSTEM,
  SUCCESS_MESSAGE_CREATE,
  SUCCESS_MESSAGE_UPDATE,
} from '../../../../../util/Constants'
import {ShowSnackBar} from '../../../../../util/functions'
import {ResizeHandle} from '../../../../hoteleria/components/Layout/Container/ResizeHandle/ResizeHandle'
import {
  createFactConfig,
  deleteFactConfig,
  updateFactConfig,
} from '../../../services/configFacturation.service'
import {funcDelete} from '../../../util/function'
import ActionsContent from '../../componentes/Actions'
import ContainerWrapper from '../../componentes/Container'
import {renderPanelContent} from '../components'
import {ConfigFacturationModelDTO} from '../../../model/configFacturation.model'
import {configFacturationSchema} from '../../../schema/configFacturation'
import {convertToDateISOString} from '../../../../../util/functions'
const ConfigFacturationPageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useCentral()
  const [loading, setLoading] = useState(false)

  const methods = useForm<ConfigFacturationModelDTO>({
    defaultValues: {
      ClienteId: '',
      SiteId: '',
      AplicacionId: '',
      VistaPermisoId: '',
      TipoDatoId: '',
      ValorInicio: '',
      ValorFin: '',
      FechaInicio: '',
      FechaFin: '',
    },
    resolver: yupResolver(configFacturationSchema),
  })
  const {reset} = methods

  const handleDelete = async () => {
    await funcDelete(
      deleteFactConfig,
      currentTabItem,
      setLoading,
      changeCurrentTabItem,
      currentTabItem.idToDelete ?? '',
    )
  }

  const onSubmit = async (data: ConfigFacturationModelDTO) => {
    try {
      setLoading(true)

      const isCreating = !currentTabItem.idToEdit
      if (data.FechaInicio) {
        data.FechaInicio = convertToDateISOString(data.FechaInicio)
      }
      if (data.FechaFin) {
        data.FechaFin = convertToDateISOString(data.FechaFin)
      }
      const response = isCreating
        ? await createFactConfig(data)
        : await updateFactConfig({...data, Id: currentTabItem.idToEdit as any})
      if (!response.data.error) {
        reset()
        const messageResponse = isCreating ? SUCCESS_MESSAGE_CREATE : SUCCESS_MESSAGE_UPDATE
        const obj: TabCentralModel = {
          ...currentTabItem,
          showPanel: false,
          content: {
            ...currentTabItem.content,
            headerPanel: 'table-config-facturation',
          },
          idToEdit: '',
          loadingTable: true,
        }
        changeCurrentTabItem(obj)
        ShowSnackBar(messageResponse)
      } else {
        ShowSnackBar(response.data.messageSystem ?? ERROR_MESSAGE_SYSTEM, 'error')
      }
    } catch (error) {
      console.error(ERROR_MESSAGE_SYSTEM, error)
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
    } finally {
      setLoading(false)
    }
  }
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          deleteClick={handleDelete}
          loading={loading}
          textComponentBack='table-config-facturation'
          textComponentGo='form-config-facturation'
        />
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-central-header-${currentTabItem.id}`}
              id={`panel-central-header-${currentTabItem.id}`}
              className={'panel__box'}
            >
              {renderPanelContent(currentTabItem.content.headerPanel)}
            </Panel>
            <>
              {currentTabItem.showPanel && (
                <>
                  <ResizeHandle />
                  <Panel
                    className={'panel__box'}
                    collapsible={true}
                    defaultSize={50}
                    order={2}
                    key={`panel-central-detail-${currentTabItem.id}`}
                    id={`panel-central-detail-${currentTabItem.id}`}
                  >
                    {renderPanelContent(currentTabItem.content.detailPanel)}
                  </Panel>
                </>
              )}
            </>
          </PanelGroup>
        </ContainerWrapper>
      </form>
    </FormProvider>
  )
}

export default ConfigFacturationPageWrapper
